export default {
    init() {
        this.allowed();
        this.customSelect();
        this.changeRow();
        this.getType();
        this.saveZipcodes();
        this.saveBlockTime();
        this.hideExamples();
        this.addInputMask();
        this.initSchedulePreview();
    },
    initSchedulePreview() {
        $(document).on('click', 'a[data-time-managment]', function(e) {
            e.preventDefault();
            const id = $(this).data('time-managment');

            $.ajax({
                type: 'GET',
                url: '/time-management/' + id + '/completed-schedule-preview',
                success: function (response) {
                    $('#completed-schedule-preview').remove();
                    $('#form-container').append(response);
                    $('#completed-schedule-preview').modal('show')
                },
            });
        });
    },
    addInputMask() {
        $('body').on('input', '.custom-minutes-input, .custom-hours-input, .custom-headsup-input', function() {
            let val = $(this).val();

            val = val.replace(/[^0-9.]/g, '');

            const parts = val.split('.');
            if (parts.length > 2) {
                val = parts[0] + '.' + parts.slice(1).join('');
            }

            let [intPart, decimalPart] = val.split('.');
            if (intPart.length > 4) intPart = intPart.slice(0, 4);

            val = decimalPart !== undefined ? intPart + '.' + decimalPart : intPart;

            $(this).val(val);
        });
    },
    customSelect() {
        // Initialize data attributes for all existing selects
        $('.windows-length-select, .heads-up-select').each(function() {
            $(this).data('current-value', $(this).val());
        });

        // Store the current value when the select gains focus
        $(document).on('focus', '.windows-length-select, .heads-up-select', function() {
            const $select = $(this);
            $select.data('current-value', $select.val());
        });

        // Handle select changes
        $(document).on('change', '.windows-length-select, .heads-up-select', function() {
            const $select = $(this);
            const previousValue = $select.data('current-value');
            const currentValue = $select.val();
            const $row = $select.closest('tr');

            if ($select.hasClass('windows-length-select')) {
                const $minutesInput = $row.find('.custom-minutes-input');
                const $hoursInput = $row.find('.custom-hours-input');
                const previousNumericValue = parseFloat(previousValue) || 0;

                $minutesInput.hide().prop('disabled', true);
                $hoursInput.hide().prop('disabled', true);

                if (currentValue === 'custom_minutes') {
                    // Convert from predefined values to custom minutes
                    let minutesValue = 0;
                    // Check if the previous value was a predefined time value (in minutes)
                    if (previousNumericValue > 0 && previousNumericValue <= 120) {
                        minutesValue = previousNumericValue;
                    }
                    $minutesInput.val(minutesValue).show().prop('disabled', false).focus();
                } else if (currentValue === 'custom_hours') {
                    // Convert from predefined values to custom hours
                    let hoursValue = 0;
                    // Check if the previous value was a predefined time value (in minutes)
                    if (previousNumericValue >= 30 && previousNumericValue <= 120) {
                        hoursValue = previousNumericValue / 60; // Convert minutes to hours
                    }
                    $hoursInput.val(hoursValue).show().prop('disabled', false).focus();
                }
            }

            if ($select.hasClass('heads-up-select')) {
                const $headsUpInput = $row.find('.custom-headsup-input');
                const previousNumericValue = parseFloat(previousValue) || 0;

                $headsUpInput.hide().prop('disabled', true);

                if (currentValue === 'custom_hours') {
                    // Set the value for heads up input
                    let hoursValue = 0;
                    // Check if the previous value was a predefined time value (in hours)
                    if (previousNumericValue > 0 && previousNumericValue <= 24) {
                        hoursValue = previousNumericValue;
                    }
                    $headsUpInput.val(hoursValue).show().prop('disabled', false).focus();
                }
            }

            // Update the stored value
            $select.data('current-value', currentValue);
        });

        // Handle blur events for custom inputs to set 0 if empty
        $(document).on('blur', '.custom-minutes-input, .custom-hours-input, .custom-headsup-input', function() {
            const $input = $(this);
            const value = $input.val().trim();

            if (value === '') {
                $input.val('0');
            }
        });
    },
    allowed() {
        let $this = this;
        $('body').on('change', '#time-management .windows-length-select, #time-management .heads-up-select', function(e) {
            e.preventDefault();
            const $tr = $(this).closest('tr');
            const val = $(this).val();

            if (val !== 'custom_minutes' && val !== 'custom_hours') {
                $this.sendData($tr);
            }
        });
    },
    changeRow() {
        let $this = this;
        $('body').on('change', '#time-management .allowed, #time-management .custom-hours-input, #time-management .custom-headsup-input, #time-management .custom-minutes-input', function(e) {
            e.preventDefault();
            const $tr = $(this).closest('tr');
            $this.sendData($tr);
        });
    },
    sendData(tr) {
        let windowSelect = $(tr).find('.windows-length-select');
        let headsUpSelect = $(tr).find('.heads-up-select');

        let windowValue = windowSelect.val();
        let headsUpValue = headsUpSelect.val();
        if (windowValue === 'custom_minutes') {
            let customInput = $(tr).find('input[placeholder="mins"]');
            windowValue = parseFloat(customInput.val() || 0); // в минутах
        } else if (windowValue === 'custom_hours') {
            let customInput = $(tr).find('input[placeholder="hrs"]');
            windowValue = parseFloat(customInput.val() || 0) * 60; // часы → минуты
        }
        if (headsUpValue === 'custom_hours') {
            let customInput = $(tr).find('td:eq(2) input[placeholder="hrs"]');
            headsUpValue = parseFloat(customInput.val() || 0); // часы (дробные можно)
        }

        const allowed = $(tr).find('.allowed').prop('checked') ? 1 : 0;

        if (!allowed) {
            windowSelect.val(60);
        }

        $.ajax({
            type: 'POST',
            url: '/time-management/save',
            data: ({
                organisation_id: $(tr).data('organisation_id'),
                direction: $(tr).data('direction'),
                type: $(tr).data('type'),
                service: $(tr).data('service'),
                day_of_week: $(tr).data('day_of_week'),
                hour: $(tr).data('hour'),
                mins: windowValue,
                difference: headsUpValue,
                allowed: allowed,
            }),
            success: function (response) {
                if ($(tr).find('.allowed').prop('checked')) {
                    tr.css({"opacity": 1});
                    tr.find('select').prop('disabled', false);
                    tr.find('input').not('.allowed').prop('disabled', false);
                    tr.find('.customer-view').html(`
                        <a href="#" data-time-management="${response.id}" data-form-type="create" data-create-order-link="" class="text-danger text-decoration-underline"
                                                        style="font-family: Rubik;
                                                            font-weight: 500;
                                                            font-style: Medium;
                                                            font-size: 16px;
                                                            leading-trim: NONE;
                                                            line-height: 16px;
                                                            letter-spacing: 0%;
                                                            text-align: center;
                                                            vertical-align: middle;
                                                            text-decoration: underline;
                                                            text-decoration-style: solid;
                                                            text-decoration-offset: 0%;
                                                            text-decoration-thickness: 0%;
                                                            text-decoration-skip-ink: auto;
                                                    ">
                                                        View Complete Schedule
                                                    </a>
                                                    <p style="
                                                        font-family: Rubik;
                                                        font-weight: 400;
                                                        font-style: Regular;
                                                        font-size: 14px;
                                                        leading-trim: NONE;
                                                        line-height: 16px;
                                                        letter-spacing: 0%;
                                                        text-align: center;
                                                        vertical-align: middle;
                                                        margin-bottom: 0 !important;
                                                    ">
                                                        customer will see at ${tr.find('.hour').html()}
                                                    </p>
                    `);
                } else {
                    tr.css({"opacity": 0.5});
                    tr.find('select').prop('disabled', true);
                    tr.find('input').not('.allowed').prop('disabled', true);
                    tr.find('.customer-view').html(response.direction_time);
                }

                tr.find('.direction-time').html(response.direction_time);
            },
        });
    },
    getType() {
        $('body').on('click', '#time-management .type', function(e) {
            e.preventDefault();
            let type = $(this).data('type');
            let service = $('#time-management .service.btn-primary').data('service');
            let weekday = $('#time-management .weekday.btn-primary').data('weekday');
            window.location.href='/admin/time-management?type='+type+'&service='+service+'&day_of_week='+weekday;
        });
    },
    saveZipcodes() {
        $('body').on('change', '#time-management #zipcodes', function(e) {
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: '/time-management/save-zipcodes-exceptions',
                data: ({
                    zipcodes: $(this).val()
                }),
                success: function (response) {
                },
            });
        });
    },
    saveBlockTime() {
        $('body').on('change', '#time-management #block-time', function(e) {
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: '/time-management/save-block-time',
                data: ({
                    block_time: $(this).val()
                }),
                success: function (response) {
                },
            });
        });
    },
    hideExamples(){
        $('#hide_example').click(function() {
            if ($('#hide_example').text().trim().toLowerCase() == 'hide examples') {
                $('#example-area').hide();
                $('#hide_example').text('Show examples');
            } else {
                $('#example-area').show();
                $('#hide_example').text('Hide examples');
            }
        });
    }
}
